import { configureStore } from "@reduxjs/toolkit";
import CustomizerReducer from "./customizer/CustomizerSlice";
import headerTitleReducer from "./reducers/headerTitleSlice";
import toasterReducer from "./reducers/toasterSlice";
import spinnerReducer from "./reducers/spinnerSlice";
import tokenReducer from "./reducers/tokenSlice";
import dropdownReducer from "./reducers/dropdownSlice";

export const store = configureStore({
  reducer: {
    authToken: tokenReducer,
    customizer: CustomizerReducer,
    headerTitle: headerTitleReducer,
    toaster: toasterReducer,
    spinner: spinnerReducer,
    dropdown: dropdownReducer,
  },
});

export default store;
